import React, { useState, useEffect, useContext } from "react";
import { Chart } from "react-google-charts";
import { busca_media_comparativa_geral } from "../../services/api";
import { ConverteSerie, ConverteSegmentoSig, ordem } from "./modulo";

const Media_Comparativa_geral = (props) => {

    // let avaliacao_def = props.av;
    let avaliacao = props.av;
    const [data2, setData2] = useState([]);
    // const [avaliacao, setAvaliacao] = useState('AS1');
    const [serie, setSerie] = useState('1-1');

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', '', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes'];

    let cod_unidade = props.un;

    // Lista de opções para os ComboBoxes
    const avaliacaoOptions = ['AS1', 'AQ1', 'AP1', 'AV1', 'AS2', 'AQ2', 'AP2', 'AV2', 'AS3', 'AQ3', 'AP3', 'AV3', 'AS4', 'AQ4', 'AP4', 'AV4'];
    const serieOptions = [
        { value: '1-1', label: '1º Fund I' },
        { value: '1-2', label: '2º Fund I' },
        { value: '1-3', label: '3º Fund I' },
        { value: '1-4', label: '4º Fund I' },
        { value: '1-5', label: '5º Fund I' },
        { value: '1-6', label: '6º Fund II' },
        { value: '1-7', label: '7º Fund II' },
        { value: '1-8', label: '8º Fund II' },
        { value: '1-9', label: '9º Fund II' },
        { value: '2-1', label: '1ª Médio' },
        { value: '2-2', label: '2ª Médio' },
        { value: '2-3', label: '3ª Médio' },
    ];

    const fetchData = async () => {
        try {
            const response = await busca_media_comparativa_geral(avaliacao);;
            console.log("RES=", response);
            setData2(response);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [serie, avaliacao]);

    let chartDatSerie = [];

    // let data2Filter = data2.filter(item => item.unidade === cod_unidade);

    // console.log('data2Filter', data2Filter)

    if (typeof data2 !== 'undefined') {
        chartDatSerie = data2.map((item, index) => {
            const row = [unidades[parseInt(item.unidade)]];
            row.push(ConverteSerie(item.segmento));
            row.push(item.turma);
            row.push(item.disciplina);
            row.push((parseFloat(item.media)) - parseFloat(item.media_rede))
            row.push(parseFloat(item.media));
            row.push(parseFloat(item.media_rede));
            row.push(item.nome_professor);
            return row;

        });
    };


    //chartDatSerie.sort();
    chartDatSerie.unshift(["Unidade", "Série", "Turma", "Disciplina", "Turma VS REDE ", "Média da turma", "Média SMRede", "Professor"]);

    const options = {
        allowHtml: true,
    };

    const formatters = [
        {
            type: "BarFormat",
            column: 4,
            showValue: false,
        },
        {
            type: "ColorFormat",
            column: 4,
            ranges: [
                [-10, -2, "white", "red"],
                [-2, -1.5, "white", "orange"],
                [-1.5, -1, "red", "white"],
                [-1, 0, "orange", "white"],
                [0, 1, "green", "white"],
                [1, 2, "blue", "white"],
                [2, 10.1, "white", "blue"],
            ],
        },
        // {
        //     type: "ColorFormat",
        //     column: 4,
        //     ranges: [
        //         [0, 7, "red", "white"],
        //         [7, 10.1, "blue", "white"],
        //     ],
        // },
        // {
        //     type: "ColorFormat",
        //     column: 5,
        //     ranges: [
        //         [0, 7, "red", "white"],
        //         [7, 10.1, "blue", "white"],
        //     ],
        // },
    ];


    return (
        <div className="Evasão" style={{ border: "1px solid #ccc", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", padding: "20px", borderRadius: "8px" }}>
            <center>
                <h5>
                    Nota Média dos alunos por turma e disciplina - {avaliacao}.
                </h5>
            </center>
            {/* <label>
                Avaliação:
                <select value={avaliacao} onChange={(e) => setAvaliacao(e.target.value)}>
                    {avaliacaoOptions.map((option) => (
                        <option key={option} value={option}>
                            {option}
                        </option>
                    ))}
                </select>
            </label> */}
            <br />
            <br />
            <Chart
                chartType="Table"
                width="100%"
                data={chartDatSerie}
                options={options}
                formatters={formatters}
                controls={[
                    {
                        controlEvents: [
                            {
                                eventName: "statechange",
                                callback: ({ chartWrapper, controlWrapper }) => {
                                    console.log("State changed to", controlWrapper?.getState());
                                },
                            },
                        ],
                        controlType: "CategoryFilter",
                        options: {
                            filterColumnIndex: 0,
                            ui: {
                                labelStacking: "vertical",
                                label: "Unidade",
                                allowTyping: false,
                                allowMultiple: true,
                            },
                        },
                    },
                    {
                        controlEvents: [
                            {
                                eventName: "statechange",
                                callback: ({ chartWrapper, controlWrapper }) => {
                                    console.log("State changed to", controlWrapper?.getState());
                                },
                            },
                        ],
                        controlType: "CategoryFilter",
                        options: {
                            filterColumnIndex: 1,
                            ui: {
                                labelStacking: "vertical",
                                label: "Série",
                                allowTyping: false,
                                allowMultiple: true,
                            },
                        },
                    },
                    {
                        controlEvents: [
                            {
                                eventName: "statechange",
                                callback: ({ chartWrapper, controlWrapper }) => {
                                    console.log("State changed to", controlWrapper?.getState());
                                },
                            },
                        ],
                        controlType: "CategoryFilter",
                        options: {
                            filterColumnIndex: 3,
                            ui: {
                                labelStacking: "vertical",
                                label: "Disciplina",
                                allowTyping: false,
                                allowMultiple: true,
                            },
                        },
                    },
                    {
                        controlEvents: [
                            {
                                eventName: "statechange",
                                callback: ({ chartWrapper, controlWrapper }) => {
                                    console.log("State changed to", controlWrapper?.getState());
                                },
                            },
                        ],
                        controlType: "CategoryFilter",
                        options: {
                            filterColumnIndex: 7,
                            ui: {
                                labelStacking: "vertical",
                                label: "Professor",
                                allowTyping: false,
                                allowMultiple: true,
                            },
                        },
                    },
                ]}
            />
        </div>
    );
};

export default Media_Comparativa_geral;
